// Dependencies
import styled from 'styled-components';

const alignment = (props) => (props?.alignment ? props?.alignment : 'left');
const textAlignment = alignment;

const flexAlignments = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const TitleStyles = styled.section`
  margin: 0 0 4rem;

  .inner {
    display: flex;
    justify-content: ${(props) => flexAlignments[props?.alignment]};
    width: 100%;
    text-align: ${textAlignment};

    .title {
      max-width: 60rem;
      margin: 0;
      font-size: 1.5rem;
    }
  }

  @media (min-width: 768px) {
    margin: 0 0 6rem;

    .inner {
      .title {
        font-size: 2rem;
      }
    }
  }
`;

export default TitleStyles;
